import { fetchAllProductsProducts } from './fetchAllProductsProducts';
import { Pagination } from '../../../models/Pagination';
import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../config';
import { browserClient } from '../../react-query';
import { log } from '../../shared/utils/log';
import { globalErrorResponse } from '../../shared/notification/actions';
import { AxiosError } from 'axios';
import { ProductFilter } from '../../store/api';

type Props = {
    readonly filterMap: ProductFilter;
    readonly pagination: Pagination;
    readonly loanFormat: string;
    readonly ageCategory?: string;
    readonly shopLanguage: string | undefined;
};

const ALL_PRODUCTS_KEY = 'standardAllProductsProducts';

export const useAllProductsProducts = ({ pagination, filterMap, loanFormat, ageCategory, shopLanguage }: Props) => {
    return useQuery(
        [ALL_PRODUCTS_KEY, { filterMap, loanFormat, ageCategory, shopLanguage, ...pagination }],
        () =>
            fetchAllProductsProducts({
                loanFormat,
                ageCategory,
                shopLanguage,
                pagination,
                filterMap
            }),
        {
            ...GlobalReactQueryOptions,
            onError: (error: AxiosError) => {
                log.error(error);
                if (error.response?.status !== 404) {
                    globalErrorResponse(error);
                }
            }
        }
    );
};

export function invalidateAllProductsProducts() {
    return browserClient.invalidateQueries({ queryKey: [ALL_PRODUCTS_KEY] });
}
